<template>
  <div>
    <el-page-header @back="goBack" content="新增试卷" style="margin-bottom: 10px">
    </el-page-header>
    <div style="margin-top: 20px">
      <el-form ref="form" :model="paper" label-width="120px">
        <el-form-item label="试卷名称" required>
          <el-input v-model="paper.name" style="width: 30%"></el-input>
        </el-form-item>
        <el-form-item label="单选题">
          <el-button type="success" size="small" @click="addQuestion(1)">添加单选题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==1">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="多选题">
          <el-button type="success" size="small" @click="addQuestion(2)">添加多选题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==2">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="判断题">
          <el-button type="success" size="small" @click="addQuestion(3)">添加判断题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==3">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="填空题">
          <el-button type="success" size="small" @click="addQuestion(4)">添加填空题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==4">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="名词解释题">
          <el-button type="success" size="small" @click="addQuestion(5)">添加名词解释题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==5">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="论述题">
          <el-button type="success" size="small" @click="addQuestion(6)">添加论述题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==6">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="简答题">
          <el-button type="success" size="small" @click="addQuestion(7)">添加简答题</el-button>
          <div v-for="item in paperQuestion">
            <div v-if="item.type==7">
              {{item.question}}
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button  @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>

    </div>
    <el-dialog :title="'新增'+TypeList[type]" :visible.sync="dialogFormVisible">
      <el-form :model="question">
        <el-form-item label="题型" :label-width="formLabelWidth">
          <el-input v-model="TypeList[type]" autocomplete="off" readonly></el-input>
        </el-form-item>
        <el-form-item label="医学题型分类" :label-width="formLabelWidth" required>
          <el-input v-model="question.category" autocomplete="off"
                    placeholder="请填写医学题型分类（A1~A4、B1、B2、X等）"></el-input>
        </el-form-item>
        <el-form-item label="分值" :label-width="formLabelWidth" required>
          <el-input v-model="question.points" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="题干" :label-width="formLabelWidth" required>
          <el-input v-model="question.question" autocomplete="off" placeholder="请填写题干"></el-input>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="type==1" required>
          <div v-for="(item,index) in singleSelect">
            <el-radio v-model="singleAnswer" :label="item.answer">{{item.answer+'.'}}
              <el-input v-model="item.content" autocomplete="off" placeholder="请填选项"></el-input><i class="el-icon-delete" @click="deleteSingle(index)"></i>
            </el-radio>
          </div>
          <el-button type="primary" @click="addSingleSelect">添加选项</el-button>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="type==2" required>
          <div v-for="(item,index) in manySelect">
            <el-checkbox-group v-model="manyAnswer">
            <el-checkbox  :label="item.answer">{{item.answer+'.'}}
              <el-input v-model="item.content" autocomplete="off" placeholder="请填选项"></el-input><i class="el-icon-delete" @click="deleteMany(index)"></i>
            </el-checkbox>
            </el-checkbox-group>
          </div>
          <el-button type="primary" @click="addManySelect">添加选项</el-button>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="type==3" required>
          <el-radio v-model="question.answer" label="正确"></el-radio>
          <el-radio v-model="question.answer" label="错误"></el-radio>
        </el-form-item>
        <el-form-item label="参考评分点" :label-width="formLabelWidth"  v-if="type!==2&&type!==1&&type!==3" required>
          <el-input type="textarea" v-model="question.answer" autocomplete="off" placeholder="请填写参考评分点，多个参考评分点请换行"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="pushQuestion()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
    const TypeList = {1: '单选题', 2: '多选题', 3: '判断题', 4: '填空题', 5: '名词解释题', 6: '论述题', 7: '简答题'};
    const Select = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
    export default {
        name: "addQuestion",
        data() {
            return {
                formLabelWidth: '120px',
                singleSelect: [],
                manySelect: [],
                singleAnswer:'',
                manyAnswer:[],
                TypeList,
                Select,
                type: 1,
                paper: {name:'',question:[]},
                question: {},
                paperQuestion:[],
                dialogFormVisible: false,
            };
        },
        created() {
        },
        methods: {
            deleteSingle(index){
                this.singleSelect.splice(index,1)
                this.singleSelect.forEach((value,index) => {
                    value.answer=Select[index]
                })
            },
            deleteMany(index){
                this.manySelect.splice(index-1,1)
                this.manySelect.forEach((value,index) => {
                    value.answer=Select[index]
                })
            },
            addSingleSelect() {
                if (this.singleSelect.length>14)
                {
                    this.$message.error('选项过多！')
                    return false;
                }
                const answer = Select[this.singleSelect.length];
                this.singleSelect.push({
                    answer: answer,
                    content: ''
                })
            },
            addManySelect() {
                if (this.manySelect.length>14)
                {
                    this.$message.error('选项过多！')
                    return false;
                }
                const answer = Select[this.manySelect.length];
                this.manySelect.push({
                    answer: answer,
                    content: ''
                })
            },
            goBack() {
                this.$router.back();
            },
            pushQuestion(){
               const question=this.question;
                question.type=this.type;
                if (this.type==1)
                {
                    question.answer=this.singleAnswer;
                    this.singleSelect.forEach((value,index)=>{
                        question.content+=value.answer+'.'+value.content+'&&'
                    })
                }
                if (this.type==2)
                {
                    question.answer=this.singleAnswer;
                    this.manySelect.forEach((value,index)=>{
                        question.answer+=value.answer.replace(/\s/g,"")
                        question.content+=value.answer+'.'+value.content+'&&'
                    })
                }
                this.paperQuestion.push(question)
                this.dialogFormVisible = false;
            },
            onSubmit() {
                this.paper.question=this.paperQuestion
            },
            addQuestion(type) {
                this.type = type;
                this.question = {};
                this.singleSelect = [];
                this.paper = [];
                this.dialogFormVisible = true;
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/theoryManage/addQuestion.vue